module.exports = __webpack_public_path__ + "img/PL00267.600f4997.png";